import { INFOMANIAK_SERVICE_IDS } from './infomaniak-service-ids.enum';
import {getServiceTitleFromServiceIdGeneric} from "@infomaniak/ngx-helpers";

/**
 * Generates automatically the title of a "service" from a serviceId
 */
export function getProductTitleFromServiceId(
  serviceId: INFOMANIAK_SERVICE_IDS,
): string {
  return getServiceTitleFromServiceIdGeneric(serviceId);
}
